import { View, Text } from "react-native";

type Props = {
  title?: string;
  text?: string;
  className?: string;
};

export function LargeText({ title, text, className }: Props) {
  return (
    <View className={`flex flex-col flex-wrap gap-3 ${className}`}>
      <Text className="text-typography-900 capitalize font-semibold text-sm mb-6">
        {title}
      </Text>
      <Text className="text-typography-800 capitalize text-sm">{text}</Text>
    </View>
  );
}
